export default __webpack_public_path__ + "static/media/yield.eeab12a1.svg";